export type { ClientFormValues } from './types/client-form';
export type { ModalOpenerType } from './types/general';
export type { OtpFormValues } from './types/otp-form';

export { default } from './client-otp-modal';
